// Authentication configuration using environment variables
// IMPORTANT: Never commit actual credentials to version control!

// Get credentials from environment variables (set in .env.local or hosting platform)
const getCredentials = () => {
    // In production, these should come from environment variables
    // For Vercel/Netlify, set these in the dashboard under "Environment Variables"
    const adminUsername = import.meta.env.VITE_ADMIN_USERNAME;
    const adminPassword = import.meta.env.VITE_ADMIN_PASSWORD;
    const reviewerUsername = import.meta.env.VITE_REVIEWER_USERNAME;
    const reviewerPassword = import.meta.env.VITE_REVIEWER_PASSWORD;

    // Only include users if credentials are configured
    const users = [];

    if (adminUsername && adminPassword) {
        users.push({
            username: adminUsername,
            password: adminPassword,
            name: "NRCF Admin"
        });
    }

    if (reviewerUsername && reviewerPassword) {
        users.push({
            username: reviewerUsername,
            password: reviewerPassword,
            name: "Thesis Reviewer"
        });
    }

    // Fallback for development only - REMOVE IN PRODUCTION
    if (users.length === 0 && import.meta.env.DEV) {
        console.warn('⚠️ No auth credentials configured. Using development defaults.');
        console.warn('⚠️ Set VITE_ADMIN_USERNAME, VITE_ADMIN_PASSWORD, etc. in .env.local');
        users.push({
            username: "dev",
            password: "dev123",
            name: "Development User"
        });
    }

    return users;
};

export const USERS = getCredentials();

export const validateUser = (username, password) => {
    const users = getCredentials(); // Re-fetch to ensure fresh credentials
    const user = users.find(u => u.username === username && u.password === password);
    if (user) {
        // Return user info without password
        const { password: _, ...userInfo } = user;
        return userInfo;
    }
    return null;
};
